export const fileGenerationMessages: Record<string, string> = {
  success: "File generation successful.",
  warning: "The file download failed.",
};
